/*
  Второй и следующие зарегистрированные на странице выписки.

  Решение владельца 01.10.2026: на странице домовой книги бывает несколько
  человек одного помещения. С 06.10.2026 их читает распознавание - каждую
  строку бланка по графам, прочитанное жёлтым, как у первого человека; кого
  распознавание не нашло, человек добавляет сам, глядя на картинку. Номер
  человека тот же, что в сообщении сервера об ошибке и в пояснениях над полями
  («Человек 2: ...»), чтобы ошибку было где искать. Графы у каждого те же, что
  у первого, - все графы бланка (`ScanPerson`).
*/

import ScanPerson from './ScanPerson.jsx'

export default function ScanPeople({ people }) {
  return (
    <div className="stack">
      {people.list.map((person, position) => (
        <fieldset key={person.key} className="scan__person">
          <legend>Человек {position + 2}</legend>
          <ScanPerson
            values={person}
            doubtful={new Set(person.doubtful ?? [])}
            onEdit={(name, value) => people.edit(person.key, name, value)}
          />
          <button type="button" className="button button--quiet" onClick={() => people.remove(person.key)}>
            Убрать человека {position + 2}
          </button>
        </fieldset>
      ))}
      <div className="row">
        <button type="button" className="button button--quiet" onClick={people.add}>
          Добавить человека со страницы
        </button>
      </div>
    </div>
  )
}
